import { render, staticRenderFns } from "./InboxIcon.vue?vue&type=template&id=cad4af3c"
import script from "./InboxIcon.vue?vue&type=script&lang=js"
export * from "./InboxIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports